import { useContext } from 'react';

import { MainContext, checkIsWebView, t } from '@ezbobdev/ui-framework';

import { ExpressButton, ExpressContinue } from '../';
import { redirectTo } from '../../utils/common';
import { pageActionType, systemEvents } from '../../utils/constants';
import { useSteps } from '../../utils/useSteps';

const PageActions = (props) => {
  const { name, actions, messagePayload } = props;

  const { shouldMoveToStep } = useSteps(props);
  const { actions: ctxActions, sdkActions } = useContext(MainContext);

  const productURL = ctxActions.settings.getUserConfigProp('product.url');

  const isWebView = checkIsWebView();

  return actions.map(({ type, url, event, direction, isWebviewAction, variant = 'contained' }, idx) => {
    switch (type) {
      case pageActionType.logout:
        if (!!isWebviewAction !== isWebView) {
          return null;
        }

        return (
          <ExpressButton
            key={idx}
            name="logout"
            variant={variant}
            onClick={() => sdkActions.users.logout(url ?? productURL)}
            fullWidth
          >
            {t(`${name}.pageActions.${idx}.label`)}
          </ExpressButton>
        );
      case pageActionType.redirect:
        if (!!isWebviewAction !== isWebView) {
          return null;
        }

        return (
          <ExpressButton
            key={idx}
            name="redirect"
            variant={variant}
            onClick={() => redirectTo(url ?? productURL, false)}
            fullWidth
          >
            {t(`${name}.pageActions.${idx}.label`)}
          </ExpressButton>
        );
      case pageActionType.newTab:
        if (!!isWebviewAction !== isWebView) {
          return null;
        }

        return (
          <ExpressButton
            key={idx}
            name="newTab"
            variant={variant}
            onClick={() => redirectTo(url ?? productURL, true)}
            fullWidth
          >
            {t(`${name}.pageActions.${idx}.label`)}
          </ExpressButton>
        );
      case pageActionType.event:
        if (!!isWebviewAction !== isWebView) {
          return null;
        }

        return (
          <ExpressButton
            key={idx}
            name="event"
            variant={variant}
            onClick={() => ctxActions.events.emit(systemEvents[event], { payload: messagePayload })}
            fullWidth
          >
            {t(`${name}.pageActions.${idx}.label`)}
          </ExpressButton>
        );
      case pageActionType.progress:
        if (!!isWebviewAction !== isWebView) {
          return null;
        }

        return (
          <ExpressContinue
            key={idx}
            variant={variant}
            shouldMoveToStep={() => shouldMoveToStep(direction)}
            fullWidth={true}
          >
            {t(`${name}.pageActions.${idx}.label`)}
          </ExpressContinue>
        );
      default:
        return null;
    }
  });
};

export default PageActions;
